export default __webpack_public_path__ + "static/media/safeweb.a074057d.png";